export default __webpack_public_path__ + "static/media/cart.022a52a7.svg";